import React, { Component } from 'react'

//Actions Imports
import {setLanguagePack, setProjects} from "../actions/redux";
import {getLanguage} from "../actions/commands";
import { httpService } from "../actions/httpService";

const RouterHOC = (WrappedRouter) => {
    return class RouterHOC extends Component {
        constructor(props){
            super(props)
            this.state = {
                loaded: false
            }

            this.getSelectedLanguage = this.getSelectedLanguage.bind(this)
            this.getContentFromStorage = this.getContentFromStorage.bind(this)
        }
        componentWillMount() {
            this.getSelectedLanguage(getLanguage())
            this.getContentFromStorage()
        }
        getContentFromStorage(){
            httpService.getContent().then((data)  => {
                this.props.dispatch(setProjects(data))
            })
        }
        getSelectedLanguage(lang){
            var languagePack = require(`../language-pack/${lang}.json`)
            this.props.dispatch(setLanguagePack(languagePack))
        }
        componentDidUpdate(){
            var {data, languagePack} = this.props
            if(!this.state.loaded && data && languagePack) {
                if(!getLanguage() === null || !languagePack.length <= 0|| !Object.values(data).length <= 0 ) {
                    this.setState({
                        loaded: true
                    })
                }
            }
        }
        render (){
            return(
                (!this.state.loaded )?<div></div>:<WrappedRouter {...this.props}/>
            )
        }
    }
}

export default RouterHOC


// WEBPACK FOOTER //
// ./src/hoc/RouterHOC.js